import { motion } from "framer-motion";

/**
 * Animated score bar 0-100.
 * variant: "default" | "warning" | "success" | "danger"
 * If invert=true, higher value is worse (e.g. ghosting_risk) — color logic flipped.
 */
export function ScoreBar({ label, value, invert = false, testId }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  let color;
  const effective = invert ? 100 - v : v;
  if (effective >= 70) color = "linear-gradient(to right, #32d583, #32d583)";
  else if (effective >= 45) color = "linear-gradient(to right, #fd267a, #ff6036)";
  else color = "linear-gradient(to right, #fdb022, #ff6036)";

  return (
    <div data-testid={testId} className="space-y-2">
      <div className="flex items-baseline justify-between">
        <span className="text-sm text-[#a8adbd]">{label}</span>
        <span className="font-display text-lg font-semibold text-white">{v}</span>
      </div>
      <div className="h-2.5 w-full overflow-hidden rounded-full bg-[#222636]">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${v}%` }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          style={{ background: color }}
          className="h-full rounded-full"
        />
      </div>
    </div>
  );
}
